import React, { useMemo } from 'react';
import { SearchResultCardStyles as S } from './SearchResultCard.styles';
import { DateTime } from 'luxon';
import ChevronRight from '@img/icons/chevron_right.svg';
const SearchResultCard = ({ tag, date, title, summary, cta, href, }) => {
    const formattedDate = useMemo(() => {
        if (date) {
            return DateTime.fromISO(date).toFormat('dd MMM yy');
        }
        return undefined;
    }, [date]);
    return (React.createElement(S.Container, { href: href, target: "_blank" },
        React.createElement(S.TopBar, null,
            tag && React.createElement(S.ThemedPill, { text: tag.text || '', colour: tag.colour }),
            formattedDate && React.createElement(S.Date, null, formattedDate)),
        React.createElement(S.Title, null, title),
        React.createElement(S.Content, null, summary),
        React.createElement(S.FakeCta, null,
            cta,
            " ",
            React.createElement(ChevronRight, null))));
};
export default SearchResultCard;
